import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mc2100',
    ecrans: ['00-2']
});
